/**
 * Portfolio export client (arc Inc 7) — the 8-tab blended workbook download.
 *
 * Backend: GET /portfolio-export?period_from=YYYY-MM&period_to=YYYY-MM (Admin-only),
 * streams an .xlsx (agreements × months per metric, historical blended with computed).
 */
import { downloadBlob } from './iaaExports';

function fileNameFromCD(cd: string, fallback: string): string {
  const star = /filename\*=UTF-8''([^;]+)/i.exec(cd);
  if (star) return decodeURIComponent(star[1]);
  const plain = /filename="?([^";]+)"?/i.exec(cd);
  return plain ? plain[1] : fallback;
}

async function detailOf(res: Response, fallback: string): Promise<string> {
  let detail: unknown = null;
  try { detail = (await res.json()).detail; } catch { /* non-JSON body */ }
  return typeof detail === 'string' ? detail : fallback;
}

export const portfolioExportApi = {
  /** Download the 8-tab blended portfolio export for [periodFrom, periodTo] ('YYYY-MM'). */
  async download(periodFrom: string, periodTo: string): Promise<void> {
    const res = await fetch(
      `/portfolio-export?period_from=${encodeURIComponent(periodFrom)}&period_to=${encodeURIComponent(periodTo)}`,
      { method: 'GET', credentials: 'include' },
    );
    if (!res.ok) throw new Error(await detailOf(res, 'The portfolio export could not be generated.'));
    const cd = res.headers.get('Content-Disposition') ?? '';
    downloadBlob(await res.blob(), fileNameFromCD(cd, `portfolio_export_${periodFrom}_to_${periodTo}.xlsx`));
  },
};
